import { createContext, useContext } from 'react';

interface NavCtxValue {
  openMobileNav: () => void;
  isMobileNavOpen: boolean;
}

export const NavContext = createContext<NavCtxValue>({
  openMobileNav: () => {},
  isMobileNavOpen: false,
});

export const useNavContext = () => useContext(NavContext);
